export default __webpack_public_path__ + "static/media/sc3.a55a53c7.jpg";